<aside class="flex h-full min-h-0 w-full flex-col bg-white">
  <div class="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 py-4">
    <lib-signal-text-field
      label="Title"
      placeholder="Untitled form"
      [value]="draft().title"
      [debounceValueChange]="false"
      (valueChange)="updateDraft('title', $event)" />

    <lib-signal-textarea
      label="Description"
      placeholder="Shown under the title"
      [rows]="3"
      [value]="draft().description"
      [debounceValueChange]="false"
      (valueChange)="updateDraft('description', $event)" />

    <div class="flex flex-col gap-2">
      <span class="text-sm font-medium text-slate-800">Theme</span>
      <p class="text-xs leading-5 text-slate-500">
        Accent color for the submit button and highlights.
      </p>
      <div class="flex flex-wrap gap-2 pt-0.5">
        @for (preset of themePresets; track preset.id) {
          <button
            type="button"
            class="theme-swatch"
            [class.theme-swatch--selected]="isThemeSelected(preset)"
            [style.background-color]="swatchHex(preset)"
            [attr.aria-label]="preset.label"
            [attr.title]="preset.label"
            [attr.aria-pressed]="isThemeSelected(preset)"
            (click)="selectTheme(preset)"></button>
        }
      </div>

      <div class="flex flex-col gap-1.5 pt-1">
        <span class="text-sm font-medium text-slate-800">Custom color</span>
        <div class="theme-custom-row">
          <lib-signal-text-field
            class="theme-custom-hex"
            label=""
            placeholder="#2563eb"
            [value]="customHex()"
            [debounceValueChange]="false"
            (valueChange)="onCustomHexChange($event)" />
          <span
            class="theme-custom-swatch"
            [style.background-color]="customHexPreview()"
            aria-hidden="true"></span>
          <button
            type="button"
            class="theme-custom-apply"
            (click)="applyCustomHex()">
            Apply
          </button>
        </div>
      </div>

      @if (customHexError(); as error) {
        <p class="text-xs font-medium text-rose-600">{{ error }}</p>
      }

      <p class="text-xs font-medium text-slate-600">{{ selectedThemeLabel() }}</p>
    </div>

    <div class="flex flex-col gap-2">
      <div>
        <span class="text-sm font-medium text-slate-800">Cover image</span>
        <p class="mt-0.5 text-xs text-slate-500">Optional image at the top of the form.</p>
      </div>

      @if (draft().coverImageUrl) {
        <div class="overflow-hidden rounded-xl border border-slate-200">
          <img
            [src]="draft().coverImageUrl"
            alt="Cover preview"
            class="h-24 w-full object-cover" />
          <div class="flex items-center gap-3 border-t border-slate-100 bg-slate-50 px-3 py-2">
            <button
              type="button"
              class="cursor-pointer text-xs font-medium text-slate-700 underline-offset-2 transition hover:text-slate-950 hover:underline"
              (click)="openCoverFilePicker()">
              Replace
            </button>
            <button
              type="button"
              class="cursor-pointer text-xs font-medium text-rose-600 underline-offset-2 transition hover:text-rose-700 hover:underline"
              (click)="clearCover()">
              Remove
            </button>
          </div>
        </div>
      } @else {
        <button
          type="button"
          class="flex w-full cursor-pointer items-center gap-3 rounded-xl border border-dashed border-slate-300 bg-slate-50/70 px-3 py-3 text-left transition hover:border-slate-400 hover:bg-slate-50"
          (click)="openCoverFilePicker()">
          <span
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white text-slate-500 ring-1 ring-slate-200">
            <app-svg-icon src="assets/icons/image-outline.svg" [size]="18" />
          </span>
          <span class="min-w-0">
            <span class="block text-sm font-medium text-slate-800">Upload cover image</span>
            <span class="mt-0.5 block text-xs text-slate-500">PNG, JPG or WEBP · max 5MB</span>
          </span>
        </button>
      }

      @if (coverError()) {
        <p class="text-xs text-rose-600">{{ coverError() }}</p>
      }

      <input
        #coverFileInput
        type="file"
        accept="image/png,image/jpeg,image/webp"
        class="sr-only"
        (change)="onCoverFileSelected($event)" />
    </div>

    <lib-signal-dropdown
      label="Input style"
      [items]="inputAppearanceOptions"
      valuePath="value"
      displayPath="label"
      [value]="draft().inputAppearance"
      [debounceValueChange]="false"
      (valueChange)="onInputAppearanceChange($event)" />
  </div>
</aside>
